import { AfterViewInit, Component, ViewChildren } from '@angular/core';
import { BallotService, EventType } from '../ballot/ballot.service';
import { Router } from '@angular/router';
import { ballotRoute, printPageRoute, signatureRoute } from '../route-names';
import { ApiAboutService} from '../Services/api-about.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatDialog } from '@angular/material/dialog';
import { BallotConfirmAmComponent } from '../ballot/ballot-confirm-am.component';
import { ScreenOrderService, SelectedReturnMethod } from '../Services/screen-order.service';
import { Ballot } from '../ballot/backend-types';
import { hasHtml } from '../Services/utils';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss'],
    standalone: false
})
export class ReviewComponent implements AfterViewInit {

  contests = this.ballotService.contests;
  readonly ballot: Ballot | undefined = this.ballotService.getBallot();
  signatureRequired = this.apiAboutService.signatureRequired;
  @ViewChildren("row") rows: any;
  routeName = "";
  returnMethod: SelectedReturnMethod;
  ballotType: EventType;

  constructor(
    private readonly ballotService: BallotService,
    private readonly router: Router,
    private readonly apiAboutService: ApiAboutService,
    private announcer: LiveAnnouncer,
    private dialog: MatDialog,
    private readonly screenOrder: ScreenOrderService,
  ) {
    this.returnMethod = this.screenOrder.selectedReturnMethod;
    this.ballotType = this.ballotService.ballotType;
  }

  ngAfterViewInit() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
    
    setTimeout(()=>{    
      this.routeName = this.router.url
      this.resetFocus();
      this.signatureRequired.next(this.ballot?.voteEventData.optionalEventConfiguration?.submitSignature ?? false);
    }, 100);
   
  }

  resetFocus() {
    let focusField = document.getElementById('accessibility-button')
    let focusFieldMobile = document.getElementById('accessibility-button-mobile')
  
    if (focusField) {
      focusField.focus()
    }

    if (focusFieldMobile) {
     focusFieldMobile.focus()
    }
  }

  isDeclineChoiceSelected(contest:number): boolean | undefined{
    let isDeclineChoice: boolean = false
    for (let choice of this.contests[contest].selections) {
      if(choice.selected && choice.declineToVoteChoice){
        isDeclineChoice = true
      }
    } 
    return isDeclineChoice
  }

  isAcclaimedSelected(contest:number): boolean | undefined{
    let isAcclaimed: boolean = false
    for (let choice of this.contests[contest].selections) {
      if(choice.selected && choice.nonSelectable){
        isAcclaimed = true
      }
    } 
    return isAcclaimed
  }

  goToBallot(contestNumber: number) {
    this.ballotService.setCurrentContest(contestNumber);
    this.router.navigate(ballotRoute);
  }
  
  goToSignaturePage() {
    this.router.navigate(signatureRoute);
  }

  goToPrintPage() {
    this.router.navigate(printPageRoute);
  }

  openSubmitModal(event: any) {
    event.preventDefault();
    this.dialog.open(BallotConfirmAmComponent, {
      data: {ballot: this.ballot}
    });
  }

  focusEvent(contestNumber: number) {
    contestNumber++
    const contestName = this.contests[contestNumber-1].contest_name.replace(/[\])}[{(]/g, '')
    if(this.ballotType === 'POLL') {
      this.announcer.announce($localize `Review poll page read the contents of this page to review your selections you can use this button if you want to go back to the poll and change your selections for` + contestName ,"assertive")
    } else {
      this.announcer.announce($localize `Review ballot page read the contents of this page to review your selections you can use this button if you want to go back to the ballot and change your selections for` + contestName ,"assertive")
    }
  }

  isStringEmpty(value: string | null | undefined): boolean {
    return (value == null || (typeof value === "string" && value.trim().length === 0));
  }

  stringHasHtml(htmlString: string): boolean {
    return hasHtml(htmlString);
  }
}